import { configureStore } from "@reduxjs/toolkit";
import quoteRedux from "./quoteRedux";

export default configureStore({
    reducer: {
        quote: quoteRedux,
    },
});
